import React from 'react';
import { TestFlightStats } from '../../types';

interface TestFlightStatsGridProps {
  stats: TestFlightStats;
  selectedGroup?: string;
}

const TestFlightStatsGrid: React.FC<TestFlightStatsGridProps> = ({ 
  stats, 
  selectedGroup 
}) => {
  const getDisplayStats = () => {
    if (selectedGroup) {
      return {
        total: stats.byGroup[selectedGroup] || 0,
        installed: stats.byGroupInstalled?.[selectedGroup] || 0,
        invited: stats.byGroupInvited?.[selectedGroup] || 0,
        groups: 1
      };
    }
    
    return {
      total: stats.total || 0,
      installed: stats.installed || 0,
      invited: stats.invited || 0,
      groups: Object.keys(stats.byGroup || {}).length
    };
  };

  const displayStats = getDisplayStats();

  return (
    <div className="testflight-stats">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{displayStats.total}</div>
          <div className="stat-label">Total Testers</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{displayStats.installed}</div>
          <div className="stat-label">Installed</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{displayStats.invited}</div>
          <div className="stat-label">Invited</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{displayStats.groups}</div>
          <div className="stat-label">Beta Groups</div>
        </div>
      </div>
    </div>
  );
};

export default TestFlightStatsGrid;
